import type {
	CommunicationExportParams,
	CommunicationListParams,
	CommunicationQueryParams,
} from "../types";

function appendGroupIds(
	searchParams: URLSearchParams,

	groupIds: number[] | undefined
): void {
	if (!groupIds?.length) {
		return;
	}

	for (const groupId of groupIds) {
		searchParams.append("GroupIds", String(groupId));
	}
}

function appendOptionalQueryFields(
	searchParams: URLSearchParams,

	query: CommunicationQueryParams
): void {
	if (query.search?.trim()) {
		searchParams.append("Search", query.search.trim());
	}

	appendGroupIds(searchParams, query.groupIds);

	if (query.status !== undefined) {
		searchParams.append("Status", String(query.status));
	}
}

export function toCommunicationApiQuery(
	params: CommunicationListParams | CommunicationExportParams
): CommunicationQueryParams {
	const query: CommunicationQueryParams = {};

	if (params.search?.trim()) {
		query.search = params.search.trim();
	}

	if (params.status !== undefined) {
		query.status = params.status;
	}

	if (params.groupIds?.length) {
		query.groupIds = params.groupIds;
	}

	return query;
}

export function toCommunicationListSearchParams(
	params: CommunicationListParams
): URLSearchParams {
	const searchParams = new URLSearchParams({
		PageNumber: String(params.pageNumber),

		PageSize: String(params.pageSize),
	});

	if (params.sortBy) {
		searchParams.append("SortBy", params.sortBy);
	}

	if (params.sortDirection) {
		searchParams.append("SortDirection", params.sortDirection);
	}

	appendOptionalQueryFields(searchParams, toCommunicationApiQuery(params));

	return searchParams;
}

export function toCommunicationAllSearchParams(
	query: CommunicationQueryParams
): URLSearchParams {
	const searchParams = new URLSearchParams();

	appendOptionalQueryFields(searchParams, query);

	return searchParams;
}
